import { StrategySettings } from '@/views/dashboard/policy/software-disabled/software-disabled.service'
import { SettingsResCommon } from '@/views/dashboard/policy/policy-common.service'

export const defaultSoftwareDisabledProcessRow = () => ({
  name: '',
  path: '',
  md5: '',
  signature: '',
})

export const DEFAULT_SETTING: StrategySettings = {
  main_switch: true,
  handle_type: 1,
  interval_type: 1,
  software_ids: [],
  process_infos: [defaultSoftwareDisabledProcessRow()],
  frequency: 1,
  regular_tasks: [{ target: 1, start_min: 0, end_min: 23 * 60 + 50 }],
  scenes: []
}

export interface SettingsRes extends SettingsResCommon {
  /** 策略内容(json) ，特定的类型才返回，如软件禁用策略 */
  strategy: StrategySettings
}
